module.exports = __webpack_public_path__ + "static/fonts/icomoon.61797c2.woff";